module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAKCAYAAADPcbwqAAAAx0lEQVQ4jc3UMUoDURCA4W+XNCJCLpAmhSBotXcQLAwphdzAG1iInsRCxNpCEDzDniEHsEiqFGlMit3FVdy365Ls+jdv5s0U/xt4EyVJIsA9RrjGOtTYljRN/9Q/CNQmuMvjU1zio53W7ogr7o/xVMoPsNq/Tj2/CR/hJT9hial/KhzhESd5/okZ5l1KhfgpfCObZsEt3rrTqScqbYkLvPp6xDuusOnBq5JiS4zx7PvEz7Ho3KiGGIeyTzbs2aURMR5w1rdIU7ZlCBhHAgPI4wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/black_left.png
// module id = cpPi
// module chunks = 1